import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

class Bar extends React.PureComponent {
    static propTypes = {
        loading: PropTypes.bool,
        data: PropTypes.object,
    };

    componentDidUpdate(prevProps) {
        const {
            loading,
            data: { _bidenRate, _trumpRate },
        } = this.props;

        /* eslint-disable no-undef */
        if (!loading && loading !== prevProps.loading) {
            TweenLite.fromTo(
                '#biden_bar',
                1,
                { width: 0 },
                {
                    width: `${_bidenRate}%`,
                },
            );

            TweenLite.fromTo(
                '#biden_icon',
                1,
                { right: 0 },
                {
                    right: `${_bidenRate}%`,
                },
            );

            TweenLite.fromTo(
                '#trump_bar',
                1,
                { width: 0 },
                {
                    width: `${_trumpRate}%`,
                },
            );

            TweenLite.fromTo(
                '#trump_icon',
                1,
                { left: 0 },
                {
                    left: `${_trumpRate}%`,
                },
            );
        }

        if (!loading && _bidenRate !== prevProps.data._bidenRate) {
            TweenLite.fromTo(
                '#biden_bar',
                1,
                { width: document.querySelector('#biden_bar').style.width },
                {
                    width: `${_bidenRate}%`,
                },
            );

            TweenLite.fromTo(
                '#biden_icon',
                1,
                { right: document.querySelector('#biden_icon').style.left },
                {
                    right: `${_bidenRate}%`,
                },
            );
        }

        if (!loading && _trumpRate !== prevProps.data._trumpRate) {
            TweenLite.fromTo(
                '#trump_bar',
                1,
                { width: document.querySelector('#trump_bar').style.width },
                {
                    width: `${_trumpRate}%`,
                },
            );

            TweenLite.fromTo(
                '#trump_icon',
                1,
                { left: document.querySelector('#trump_icon').style.right },
                {
                    left: `${_trumpRate}%`,
                },
            );
        }
        /* eslint-enable no-undef */
    }

    render() {
        const {
            data: { bidenNum, trumpNum },
        } = this.props;

        return (
            <div className={styles.bar_box}>
                <div className={styles.bar_wrapper}>
                    <div className={styles.bar}>
                        <div
                            id="trump_bar"
                            className={`${styles.trump_bar} ${trumpNum >= 270 ? styles.win_bar : ''}`}
                        />
                        <div
                            id="biden_bar"
                            className={`${styles.biden_bar} ${bidenNum >= 270 ? styles.win_bar : ''}`}
                        />
                    </div>

                    <span
                        id="trump_icon"
                        className={`${styles.trump_icon} ${trumpNum >= 270 ? styles.win_icon : ''}`}
                    />
                    <span
                        id="biden_icon"
                        className={`${styles.biden_icon} ${bidenNum >= 270 ? styles.win_icon : ''}`}
                    />
                </div>
            </div>
        );
    }
}

export default errorBoundary(Bar);
